import { AuthError, Error } from "../domain/error.model";
import { HttpErrorResponse } from "@angular/common/http";
import { DataObject } from "../domain/data-object";
import {
  AccessDenied,
  BadCredentials,
  BadRequest,
  ContentIsToBig,
  InactiveAccount,
  NoInternetConnection,
  NotFound,
  TooManyLoginAttempts,
  Unexpected,
  Violations,
} from "../domain/failures";

export function getError(e: HttpErrorResponse): Error {
  return e.error;
}

export function getAuthError(e: HttpErrorResponse): AuthError {
  return e.error;
}

export function handleError(e: HttpErrorResponse, fun?: () => DataObject | null): DataObject {
  if (!e) {
    return new DataObject(new Unexpected(), null);
  }
  if (e.status === 504) {
    return new DataObject(new NoInternetConnection(), null);
  }
  if (e.status === 413) {
    return new DataObject(new ContentIsToBig(), null);
  }
  if (e.status === 404) {
    return new DataObject(new NotFound(), null);
  }

  if (e.status === 403) {
    return new DataObject(new AccessDenied(), null);
  }

  if (e.status === 401 && e.error.error_description === "account.error.inactiveAccount") {
    return new DataObject(new InactiveAccount(), null);
  }

  if (e.status === 401 && e.error.error_description === "account.error.blockedAfterLoginAttemptsLimit") {
    return new DataObject(new TooManyLoginAttempts(), null);
  }

  if (e.status === 400 && e.error.error === "invalid_grant") {
    return new DataObject(new BadCredentials(), null);
  }

  if (e.status === 400) {
    return new DataObject(new BadRequest(BadRequest.getCode, getError(e)?.detail ?? BadRequest.getMessage), null);
  }

  if (getError(e)?.violations) {
    return new DataObject(new Violations(getError(e).violations), null);
  }

  if (fun) {
    const ret: DataObject<null> | null = fun();

    if (ret) {
      return ret;
    }
  }
  return new DataObject(new Unexpected(Unexpected.getCode, e.error?.detail), null);
}
